import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/LoginScreens/LoginPage/Login";
import SignUp from "./Pages/LoginScreens/SignupPage/SignUp";
import ForgotPassword from "./Pages/LoginScreens/ForgotPassword/ForgotPassword";
import ConfirmPassword from "./Pages/LoginScreens/ConfirmPassword/ConfirmPassword";
import Sidebar from "./Components/Dashboard/Sidebar/Sidebar";
import VerifyPassword from "./Pages/LoginScreens/VerifyPassword/VerifyPassword";
import AllEmployees from "./Pages/AdminScreens/AllEmployees/AllEmployees";
import NewEmployeesModal from "./Components/Modals/NewEmployeesModal";
import EmployeeProfile from "./Pages/AdminScreens/EmployeeProfile/EmployeeProfile";
import AddAnnouncement from "./Pages/AdminScreens/AddAnnouncement/AddAnnouncement";
import TodaysAttendance from "./Pages/AdminScreens/TodaysAttendance/TodaysAttendance";
import AttendanceSheet from "./Pages/AdminScreens/AttendanceSheet/AttendanceSheet";
import AddEmployee from "./Pages/AdminScreens/AddEmployee/AddEmployee";
import AdmDashboard from "./Components/Dashboard/AdmDashboard/Dashboard";
import EmpDashboard from "./Components/Dashboard/EmpDashboard/Dashboard";
import AllLeaveRequests from "./Pages/AdminScreens/LeaveManagement/AllLeaveRequests";
import LeaveBalance from "./Pages/AdminScreens/LeaveBalance/LeaveBalance";
import AllHolidays from "./Pages/AdminScreens/AllHolidays/AllHolidays";
import AddHolidays from "./Pages/AdminScreens/AddHolidays/AddHolidays";
import EMPattendance from "./Pages/EmployeeScreens/EMPAttendance/Empattendance";
import EMPHolidays from "./Pages/EmployeeScreens/EMPHolidays/EMPHolidays";
import EMPLeaves from "./Pages/EmployeeScreens/EMPleave/EMPLeaves";
import EMPLeavesRequest from "./Pages/EmployeeScreens/EMPLeavesRequest/EMPLeavesRequest";
import ADMLeavesRequest from "./Pages/AdminScreens/ADMLeavesRequest/ADMLeavesRequest";
import Header from "./Components/Dashboard/Header/Header";
import EMPProfile from "./Pages/EmployeeScreens/EmployeeProfile/EMPProfile";
import EMPLeavesApproval from "./Pages/EmployeeScreens/EMPLeavesApproval/EMPLeavesApproval";
import EmployeeAttendance from "./Pages/HRScreens/EmployeeAttendance/EmployeeAttendance";
import EmployeeAttendanceSheet from './Pages/HRScreens/AttendanceSheet/AttendanceSheet';
import AdminImportExcelSheet from './Pages/AdminScreens/ImportExcelSheet/ImportExcelSheet';
import Imgcroper from "./Components/imgCropper";
import AdminProfile from "./Pages/AdminScreens/AdminProfile/AdminProfile";
import Earlyclosure from "./Pages/HRScreens/Earlyclosure/Earlyclosure";
import EMPLeavesReports from "./Pages/HRScreens/LeaveReports/LeaveReports";
import ResumeUploard from "./Pages/EmployeeScreens/ResumePortal/ResumeUploard/ResumeUploard";
import ResumeDisplay from "./Pages/EmployeeScreens/ResumePortal/ResumeDisplay/ResumeDisplay";
import RecasUserTable from "./Pages/AdminScreens/Recas/RecasUserTable/RecasUserTable";
import RecasSceenshots from "./Pages/AdminScreens/Recas/RecasSceenshots/RecasSceenshots";
import TaskAssigned from "./Pages/AdminScreens/Task/TaskAssigned/TaskAssigned";
import CreateClient from "./Pages/Client/CreateClient/CreateClient";
import AllClients from "./Pages/Client/AllClient/AllClients";
import ViewTask from "./Pages/AdminScreens/Task/ViewTask/ViewTask";
import TasksInProgress from "./Pages/AdminScreens/Task/TasksInProgress/TasksInProgress";
import AdminDepartment from "./Pages/AdminScreens/AddDepartment/AddDepartment.jsx";
import SubDepartment from "./Pages/AdminScreens/AddSubDepartment/AddSubDepartment.jsx";
import EMPDailyStatus from "./Pages/EmployeeScreens/EMPDailyStatus/EMPDailyStatus.jsx";
import AdminDSR from "./Pages/AdminScreens/AdminDSR/AdminDSR.jsx";
import { ProfileProvider } from "./Context/ProfileContext.js";
import UserReport from "./Pages/AdminScreens/UserReport/UserReport.jsx";
import { ProtectedRoute } from "./Utils/utils.js";

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <BrowserRouter>
      <ProfileProvider>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/SignUp" element={<SignUp />}></Route>
          <Route path="/ForgotPassword" element={<ForgotPassword />}></Route>
          <Route path="/ConfirmPassword" element={<ConfirmPassword />}></Route>
          <Route path="/Sidebar" element={<Sidebar />}></Route>
          <Route path="/Header" element={<Header />}></Route>
          <Route path="/VerifyPassword" element={<VerifyPassword />}></Route>
          <Route path="/NewEmployeesModal" element={<NewEmployeesModal />}></Route>
          <Route element={<ProtectedRoute />}>
          {/* ########## Add  Admin Routes here ######## */}
          {/* Admin dashboard---->  */}
          <Route path="/Adm/Dashboard" element={<AdmDashboard />}></Route>
          <Route path="/Adm/Dashboard/AddAnnouncement" element={<AddAnnouncement />}></Route>
          <Route path="/Adm/Dashboard/AdminDepartment" element={<AdminDepartment/>}></Route>
          <Route path="/Adm/Dashboard/AdminSubDepartment" element={<SubDepartment/>}></Route>
          {/* Admin Employe Screens -->  */}
          <Route path="/Adm/Employees/AllEmployees" element={<AllEmployees />}></Route>
          <Route path="/Adm/Employees/AddEmployee" element={<AddEmployee />}></Route>
          <Route path="/Adm/Employees/EmployeeProfile" element={<EmployeeProfile />}></Route>
          {/* Admin Attendance Screens-->  */}
          <Route path="/Adm/Attendance/TodaysAttendance" element={<TodaysAttendance />}></Route>
          <Route path="/Adm/Attendance/AttendanceSheet" element={<AttendanceSheet />}></Route>
          <Route path="/Adm/Attendance/ImportExcel" element={<AdminImportExcelSheet />}></Route> 
          <Route path="/Adm/Attendance/EarlyClosure" element={<Earlyclosure />}></Route>
          {/* Admin Leave Management screens  */}
          <Route path="/Adm/LeaveManagement/AllLeaveRequests" element={<AllLeaveRequests />}></Route>
          <Route path="/Adm/LeaveManagement/ApplyLeaves" element={<ADMLeavesRequest />}></Route>
          <Route path="/Adm/LeaveManagement/LeaveBalance" element={<LeaveBalance />}></Route>
          <Route path="/Adm/LeaveManagement/UserReport" element={<UserReport />}></Route>
          {/* Admin Holidays screens   */}
          <Route path="/Adm/Holidays/AllHolidays" element={<AllHolidays />}></Route>
          <Route path="/Adm/Holidays/AddHolidays" element={<AddHolidays />}></Route>
          <Route path="/Adm/Profile" element={<AdminProfile/>}></Route>
          {/* Admin dsr screen   */}
          <Route path="/Adm/dailystatusreports" element={<AdminDSR />}></Route>
          {/* Add Employee Raute here  */}
          <Route path="/Emp/Dashboard" element={<EmpDashboard />}></Route>
          <Route path="/Emp/attendance" element={<EMPattendance />}></Route>
          <Route path="/Emp/EMPLeaves" element={<EMPLeaves />}></Route>
          <Route path="/Emp/EMPLeavesApproval" element={<EMPLeavesApproval />}></Route>
          <Route path="/Emp/ApplyLeaves" element={<EMPLeavesRequest />}></Route>
          <Route path="/Emp/Holidays" element={<EMPHolidays />}></Route>
          <Route path="/Emp/Profile" element={<EMPProfile />}></Route>
          <Route path="/Emp/DailyStatusReport" element={<EMPDailyStatus />}></Route>
          {/* Routes For HR  */}
          <Route path="/Hr/Getattendance" element={<EmployeeAttendance />}></Route>
          <Route path="/Hr/ImportExcel" element={<EmployeeAttendanceSheet />}></Route>
          <Route path="/imgCropper" element={<Imgcroper />}></Route>
          <Route path="/Earlyclosure" element={<Earlyclosure />}></Route>
          <Route path="/Emp/EMPLeavesReports" element={<EMPLeavesReports />}></Route>
          <Route path="/Hr/DailyStatusReport" element={<EMPDailyStatus />}></Route>
          {/* RESUME SCREEN  */}
          <Route path="/Emp/ResumeUpload" element={<ResumeUploard />}></Route>
          <Route path="/Emp/ResumeDisplay" element={<ResumeDisplay />}></Route>
          {/* RECAS SCREEN  */}
          <Route path="/Adm/RecasUserTable" element={<RecasUserTable />}></Route>
          <Route path="/Adm/RecasScreenshot" element={<RecasSceenshots />}></Route>
          {/* Task assigned  */}
          <Route path="/TaskAssigned" element={<TaskAssigned />}></Route>
          <Route path="/ViewTask" element={<ViewTask />}></Route>
          <Route path="/TasksInProgress" element={<TasksInProgress />}></Route>
          {/* Clients */}
          <Route path="/CreateClient" element={<CreateClient />}></Route>
          <Route path="/AllClients" element={<AllClients />}></Route>    
          </Route> 
        </Routes>
        </ProfileProvider>
      </BrowserRouter>
    </>
  );
}
export default App; 